import { ExpirationDate } from '@arc/unified-payments-frontend/date-utils';
import { createAction, props, union } from '@ngrx/store';

export const paymentAccountDeleted = createAction(
  '[POA Payment - Select Payment Method] Payment Account Deleted',
  props<{
    paymentAccountBurn: string;
  }>(),
);

export const paymentAccountExpirationDateUpdated = createAction(
  '[POA Payment - Select Payment Method] Payment Account Expiration Date Updated',
  props<{
    paymentAccountIdentifierBurn: string;
    expirationDate: ExpirationDate;
  }>(),
);

export const sensitiveInformationCleared = createAction(
  '[POA Review Payment] Sensitive Information Cleared',
);

const PoaBtPaySelectPaymentMethodActions = union({
  paymentAccountDeleted,
  paymentAccountExpirationDateUpdated,
  sensitiveInformationCleared,
});

export type PoaBtPaySelectPaymentMethodActionsUnion =
  typeof PoaBtPaySelectPaymentMethodActions;
